module.exports = __webpack_public_path__ + "static/media/login-background.de2c9d86.webp";